import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";

export default function AddLanguage() {

    const [language, setLanguage] = useState();
    const navigate = useNavigate();
    const adminToken = localStorage.getItem("authAdminToken");


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!language) {
            toast.info("Language field is required.");
            return;
        }

        const lang_data = {
            language: language,
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/createLanguage`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${adminToken}`
                },
                body: JSON.stringify(lang_data),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Language added successfully!");
                setLanguage("");
            } else {
                toast.error("Failed to add language. Please try again.");
                navigate('/admin/addlanguage');
            }

        } catch (error) {
            toast.error("An error occurred while adding the language. Please try again later.");
        }
    };


    return (
        <>

            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 42em" }}>
                <div className="app-ecommerce">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="card mb-6">
                                <div className="card-header">
                                    <h5 className="card-tile mb-0">Add Language Master</h5>
                                </div>
                                <div className="card-body">

                                    <form onSubmit={(event) => { handleSubmit(event) }}>
                                        <div className="row gx-5 mb-5">
                                            <div className="col">
                                                <div className="form-floating form-floating-outline">
                                                    <input type="text" className="form-control" value={language} onChange={(event) => { setLanguage(event.target.value) }} placeholder="Enter Language" />
                                                    <label htmlFor="language">Language</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3 d-flex gap-4 mx-4">
                                            <button type="submit" className="btn btn-primary">Submit</button>

                                        </div>

                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
